import SpinnerSvg from "assets/images/animated/spinner.svg";
import { ImgProps } from "types/dom";

const Spinner = (props: ImgProps) => {
  return <img src={SpinnerSvg} alt="spinner" {...props}/>;
};

export default Spinner;